'use strict';

ossFocusError.$inject = ['$timeout'];
function ossFocusError($timeout) {
    var directive = {
        restrict: 'A',
        link: link
    };

    return directive;

    function link(scope, element, attrs, ctrl) {
        //custom listener if form was not submitted
        var errorListener = scope.$on('setFocusOnError', function () {
            getFirstInvalidEl();
        });

        element.on('submit', function () {
            getFirstInvalidEl();
        });

        function getFirstInvalidEl() {
            var firstInvalid = element[0].querySelector('.ng-invalid');
            if (firstInvalid) {
                firstInvalid.focus();
            }
        }

        scope.$on('$destroy', function () {
            errorListener();
        });
    }
}

module.exports = ossFocusError;